import { render, staticRenderFns } from "./rolesTag.vue?vue&type=template&id=38f3a20e&scoped=true"
import script from "./rolesTag.vue?vue&type=script&lang=js"
export * from "./rolesTag.vue?vue&type=script&lang=js"
import style0 from "./rolesTag.vue?vue&type=style&index=0&id=38f3a20e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f3a20e",
  null
  
)

export default component.exports